import { render } from "./level-card.vue?vue&type=template&id=56480622&scoped=true&ts=true"
import script from "./level-card.vue?vue&type=script&lang=ts"
export * from "./level-card.vue?vue&type=script&lang=ts"

import "./level-card.vue?vue&type=style&index=0&id=56480622&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56480622"]])

export default __exports__